export enum ReportFormat {
  PDF = 0,
  Excel = 1,
}
